// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"long-paragraph-module--paragraph--34PjK"};